<!--
 * @Author: YuanYuan
 * @Date: 2025-03-20 10:07:46
 * @LastEditTime: 2025-05-26 18:42:49
 * @Description: 套餐选择器
-->
<template>
  <el-select v-model="selectedId" @change="updateValue" class="w-full">
    <span slot="prefix">{{$t('packages.packageID')}}{{$t('common.colon')}}</span>
    <el-option
      v-for="item in options"
      :key="item.packageId"
      :value="item.packageId">
      <span>{{item.packageId}}</span>
      <span :class="constGet('Packages/UseOptions', item.status, 'colorClazz')">
        {{$t('common.bracket', {name: constGet('Packages/UseOptions', item.status)})}}
      </span>
    </el-option>
  </el-select>
</template>

<script setup>
import { toRefs, watch, ref } from 'vue'
import { constGet } from '@/utils/base'

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  value: {
    type: [String, Number],
    default: ''
  }
})

const { options, value } = toRefs(props)
const selectedId = ref('')

const emit = defineEmits(['input'])

const updateValue = val => {
  emit('input', val)
}

watch(() => value.value, val => {
  selectedId.value = val
  updateValue(val)
})
</script>
